import { render } from "./FooterDetail.vue?vue&type=template&id=242ea359&scoped=true"
import script from "./FooterDetail.vue?vue&type=script&lang=js"
export * from "./FooterDetail.vue?vue&type=script&lang=js"

import "./FooterDetail.vue?vue&type=style&index=0&id=242ea359&scoped=true&lang=css"
import "./FooterDetail.vue?vue&type=style&index=1&id=242ea359&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242ea359"]])

export default __exports__